export { default as FarmIcon } from './farm';
export { default as KMXIcon } from './kmx';
export { default as KUSIcon } from './kus';
export { default as NFTIcon } from './nft';
export { default as PredictionIcon } from './prediction';